module.exports = __webpack_public_path__ + "img/vip_wenbv2.696997d8.png";